import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/charts/Charts')
const Widgets = () => import('@/views/widgets/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')
const Brands = () => import('@/views/icons/Brands')
const Flags = () => import('@/views/icons/Flags')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const SendEmail = () => import('@/views/pages/SendEmail')
const ResetPassword = () => import('@/views/pages/ResetPassword')
const ResetComplete = () => import('@/views/pages/ResetComplete')
const ConfirmEmail = () => import('@/views/pages/ConfirmEmail')
const Register = () => import('@/views/pages/Register')
const UserError = () => import('@/views/pages/UserError')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

// Report
const MonthlyReport = () => import('@/report/MonthlyReport')
const Roster = () => import('@/report/Roster')

// (admin)Total
const Total = () => import('@/admin/total/List')
const TotalProject = () => import('@/admin/total/List_project')
const ProjectRateSetting = () => import('@/admin/project/ProjectRateSetting')

// (admin)MonthlyReport
const MonthlyReportList = () => import('@/admin/monthly_report/List')
const MonthlyReportInfo = () => import('@/admin/monthly_report/Info')

// (admin)Roster
const RosterList = () => import('@/admin/roster/List')
const RosterInfo = () => import('@/admin/roster/Info')

// (admin)PaidAndSubstitute
const PaidAndSubstituteListAdmin = () => import('@/admin/paid_and_substitute/List')
const PaidAndSubstituteInfoAdmin = () => import('@/admin/paid_and_substitute/Info')

// (admin)Overtime
const OvertimeListAdmin = () => import('@/admin/overtime/List')
const OvertimeInfoAdmin = () => import('@/admin/overtime/Info')

// (admin)HolidayWork
const HolidayWorkListAdmin = () => import('@/admin/holiday_work/List')
const HolidayWorkInfoAdmin = () => import('@/admin/holiday_work/Info')

// (admin)PayOff/Expense
const ExpenseListAdmin = () => import('@/admin/payoff/ExpenseList')
const ExpenseInfoAdmin = () => import('@/admin/payoff/Expense')

// (admin)PayOff/TravelCost
const TravelCostListAdmin = () => import('@/admin/payoff/TravelCostList')
const TravelCostInfoAdmin = () => import('@/admin/payoff/TravelCostInfo')

// Project
const ProjectRegister = () => import('@/project/ProjectRegister')
const ProjectList = () => import('@/project/ProjectList')
const ProjectInfo = () => import('@/project/ProjectInfo')
const ProjectUpdate = () => import('@/project/ProjectUpdate')

// Department
const DepartmentList = () => import('@/department/List')
const DepartmentInfo = () => import('@/department/Info')
const DepartmentRegisterInput = () => import('@/department/RegisterInput')
const DepartmentUpdateInput = () => import('@/department/UpdateInput')

// Sales
const SalesManagement = () => import('@/admin/sales/SalesManagement')

// Management insights
const WorkforceHeatmap = () => import('@/admin/insights/WorkforceHeatmap')
const PaidLeavePlanner = () => import('@/insights/PaidLeavePlanner')
const ProjectProfitForecast = () => import('@/admin/insights/ProjectProfitForecast')
const CashFlowForecast = () => import('@/admin/insights/CashFlowForecast')

// User
const List = () => import('@/user/List')
const Info = () => import('@/user/Info')
const RegisterInput = () => import('@/user/RegisterInput')
const UpdateInput = () => import('@/user/UpdateInput')

// Client
const ClientList = () => import('@/client/ClientList')
const ClientInfo = () => import('@/client/ClientInfo')
const ClientRegister = () => import('@/client/ClientRegister')
const ClientUpdate = () => import('@/client/ClientUpdate')

// Setting
const Setting = () => import('@/setting/Setting')
const SettingUpdate = () => import('@/setting/SettingUpdate')

// PaidAndSubstitute
const paidAndSubstituteList = () => import('@/request/paid_and_substitute/List')
const paidAndSubstituteInfo = () => import('@/request/paid_and_substitute/Info')
const paidAndSubstituteRegisterInput = () => import('@/request/paid_and_substitute/RegisterInput')
const paidAndSubstituteUpdateInput = () => import('@/request/paid_and_substitute/UpdateInput')

// Overtime
const OvertimeList = () => import('@/request/overtime/List')
const OvertimeInfo = () => import('@/request/overtime/Info')
const OvertimeRegisterInput = () => import('@/request/overtime/RegisterInput')
const OvertimeUpdateInput = () => import('@/request/overtime/UpdateInput')

// HolidayWorks
const HolidayWorkList = () => import('@/request/holiday_work/List')
const HolidayWorkInfo = () => import('@/request/holiday_work/Info')
const HolidayWorkRegisterInput = () => import('@/request/holiday_work/RegisterInput')
const HolidayWorkUpdateInput = () => import('@/request/holiday_work/UpdateInput')

// Request - PayOff
const TravelCost = () => import('@/request/payoff/TravelCost')
const Expense = () => import('@/request/payoff/Expense')

// SubmissionApproval
const ReportList = () => import('@/submission_approval/ReportList')
const SubmissionManagement = () => import('@/submission_approval/SubmissionManagement')

Vue.use(Router)

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Home',
          component: Dashboard
        },
        {
          path: 'insights/paid-leave',
          name: '有休取得プランナー',
          component: PaidLeavePlanner,
          meta: { requiresAuth: true }
        },
        {
          path: 'admin/insights/workforce',
          name: '人員×プロジェクト稼働',
          component: WorkforceHeatmap,
          meta: { requiresAuth: true }
        },
        {
          path: 'admin/insights/project-profit',
          name: 'プロジェクト収益予測',
          component: ProjectProfitForecast,
          meta: { requiresAuth: true }
        },
        {
          path: 'admin/insights/cash-flow',
          name: '入金・請求予測',
          component: CashFlowForecast,
          meta: { requiresAuth: true }
        },
        {
          path: 'project/search/:id',
          name: 'プロジェクト検索詳細',
          component: ProjectInfo,
          meta: { requiresAuth: true }
        },
        {
          path: 'users',
          redirect: '/users/list',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'ユーザ管理',
              component: List,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'list',
              name: 'ユーザ管理',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: '/users/:id',
                  name: 'ユーザ詳細',
                  component: Info,
                  meta: {
                    requiresAuth: true
                  },
                },
                {
                  path: 'info',
                  name: 'ユーザ詳細',
                  component: {
                    render (c) { return c('router-view') }
                  },
                  children: [
                    {
                      path: '/users/:id/edit',
                      name: 'ユーザ更新',
                      component: UpdateInput,
                      meta: {
                        requiresAuth: true
                      },
                    }
                  ]
                },
                {
                  path: '/users/register',
                  name: 'ユーザ登録',
                  component: RegisterInput,
                  meta: {
                    requiresAuth: true
                  },
                },
              ]
            }
          ]
        },
        {
          path: 'department',
          redirect: '/department/list',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'pic',
              name: '組織図',
              component: DepartmentList,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'list',
              name: '部署管理',
              component: DepartmentList,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'register',
              name: '部署登録',
              component: DepartmentRegisterInput,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'list',
              name: '部署管理',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: '/department/:id',
                  name: '部署詳細',
                  component: DepartmentInfo,
                  meta: {
                    requiresAuth: true
                  },
                },
                {
                  path: '/department/:id/edit',
                  name: '部署更新',
                  component: DepartmentUpdateInput,
                  meta: {
                    requiresAuth: true
                  },
                }
              ]
            }
          ]
        },
        {
          path: 'paidandsubstitutes',
          name: '休暇申請',
          redirect: '/paidandsubstitutes/list',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
            path: 'list',
            component: paidAndSubstituteList
          }, {
            path: 'list',
            component: {
              render(c) {
                return c('router-view')
              }
            },
            children: [{
              path: '/paidandsubstitutes/:id',
              name: '休暇申請詳細',
              component: paidAndSubstituteInfo
            }, {
              path: '/paidandsubstitutes/:id',
              name: '休暇申請詳細',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [{
                path: '/paidandsubstitutes/:id/edit',
                name: '休暇申請修正',
                component: paidAndSubstituteUpdateInput
              }]
            }, {
              path: 'register',
              name: '休暇申請作成',
              component: paidAndSubstituteRegisterInput
            }]
          }]
        },
        {
          path: 'overtimes',
          name: '予定外時間外報告',
          redirect: '/overtimes/list',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: 'list',
              component: OvertimeList
            }, {
              path: 'list',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [{
                  path: '/overtimes/:id',
                  name: '予定外時間外報告詳細',
                  component: OvertimeInfo
                }, {
                  path: '/overtimes/:id',
                  name: '予定外時間外報告詳細',
                  component: {
                    render(c) {
                      return c('router-view')
                    }
                },
                children: [{
                  path: '/overtimes/:id/edit',
                  name: '予定外時間外報告修正',
                  component: OvertimeUpdateInput
                }]
              },
              {
                path: 'register',
                name: '予定外時間外報告作成',
                component: OvertimeRegisterInput
              }]
          }]
        },
        {
          path: 'holidayworks',
          name: '休日出勤報告',
          redirect: '/holidayworks/list',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
            path: 'list',
            component: HolidayWorkList
          }, {
            path: 'list',
            component: {
              render(c) {
                return c('router-view')
              }
            },
            children: [{
              path: '/holidayworks/:id',
              name: '休日出勤報告詳細',
              component: HolidayWorkInfo
            }, {
              path: '/holidayworks/:id',
              name: '休日出勤報告詳細',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [{
                path: '/holidayworks/:id/edit',
                name: '休日出勤報告修正',
                component: HolidayWorkUpdateInput
              }]
            }, {
              path: 'register',
              name: '休日出勤報告作成',
              component: HolidayWorkRegisterInput
            }]
          }]
        },
        {
          path: 'client',
          redirect: '/client/list',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'クライアント管理',
              component: ClientList
            },
            {
              path: 'list',
              name: 'クライアント管理',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'clientinfo',
                  name: 'クライアント詳細',
                  component: ClientInfo
                },
                {
                  path: 'clientinfo',
                  name: 'クライアント詳細',
                  component: {
                    render (c) { return c('router-view') }
                  },
                  children: [
                    {
                      path: 'clientupdate',
                      name: 'クライアント更新',
                      component: ClientUpdate
                    }
                  ]
                },
                {
                  path: 'clientregister',
                  name: 'クライアント登録',
                  component: ClientRegister
                }
              ]
            }
          ]
        },
        {
          path: 'project',
          redirect: '/project/list',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'プロジェクト管理',
              component: ProjectList
            },
            {
              path: 'list',
              name: 'プロジェクト管理',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'projectinfo',
                  name: 'プロジェクト詳細',
                  component: ProjectInfo
                },
                {
                  path: 'projectinfo',
                  name: 'プロジェクト詳細',
                  component: {
                    render (c) { return c('router-view') }
                  },
                  children: [
                    {
                      path: 'projectupdate',
                      name: 'プロジェクト更新',
                      component: ProjectUpdate
                    }
                  ]
                },
                {
                  path: 'projectreister',
                  name: 'プロジェクト登録',
                  component: ProjectRegister
                }
              ]
            }
          ]
        },
         {
          path: 'setting',
          redirect: '/setting/info',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'info',
              name: '設定',
              component: Setting,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'info',
              name: '設定',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'SettingUpdate',
                  name: '設定更新',
                  component: SettingUpdate,
                  meta: {
                    requiresAuth: true
                  },
                },
              ]
            }
          ]
        },
        {
          path: 'report',
          redirect: '/report/monthlyreport',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'monthlyreport',
              name: '業務報告',
              component: MonthlyReport
            },
            {
              path: 'roster',
              name: '勤務表',
              component: Roster
            },
          ]
        },
        {
          path: 'admin/monthlyreports',
          redirect: '/admin/monthlyreports/list',
          name: '業務報告一覧',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              component: MonthlyReportList,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: ':id/:user_id/:year/:month',
              name: '業務報告詳細',
              component: MonthlyReportInfo,
              meta: {
                requiresAuth: true
              },
            }
          ]
        },
        {
          path: 'admin/total',
          redirect: '/admin/total/list',
          name: '月次集計',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              component: Total,
              meta: {
                requiresAuth: true
              },
            }
          ]
        },
        {
          path: 'admin/project-rate',
          name: 'プロジェクト単価設定',
          component: ProjectRateSetting,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'admin/sales',
          redirect: '/admin/sales/salesManagement',
          name: '売上管理/請求書発行',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'salesManagement',
              component: SalesManagement,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'admin/total',
          redirect: '/admin/total/list_project',
          name: '期間集計',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list_project',
              component: TotalProject,
              meta: {
                requiresAuth: true
              },
            }
          ]
        },
        {
          path: 'admin/roster',
          redirect: '/admin/roster/list',
          name: '勤務表一覧',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              component: RosterList,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: ':user_id/:year/:month/:user_name',
              name: '勤務表詳細',
              component: RosterInfo,
              meta: {
                requiresAuth: true
              },
            }
          ]
        },
        {
          path: 'admin/paidandsubstitute',
          redirect: '/admin/paidandsubstitute/list',
          name: '休暇申請一覧',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              component: PaidAndSubstituteListAdmin,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: ':id',
              name: '休暇申請詳細(管理者)',
              component: PaidAndSubstituteInfoAdmin,
              meta: {
                requiresAuth: true
              },
            }
          ]
        },
        {
          path: 'admin/overtime',
          redirect: '/admin/overtime/list',
          name: '予定外時間外報告一覧',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              component: OvertimeListAdmin,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: ':id',
              name: '予定外時間外報告詳細(管理者)',
              component: OvertimeInfoAdmin,
              meta: {
                requiresAuth: true
              },
            }
          ]
        },
        {
          path: 'admin/holidaywork',
          redirect: '/admin/holidaywork/list',
          name: '休日出勤報告一覧',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              component: HolidayWorkListAdmin,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: ':id',
              name: '休日出勤報告詳細(管理者)',
              component: HolidayWorkInfoAdmin,
              meta: {
                requiresAuth: true
              },
            }
          ]
        },
        {
          path: 'admin/payoff',
          redirect: 'admin/payoff/expenseList',
          name: '経費精算一覧',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'expenseList',
              component: ExpenseListAdmin,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: '/expenseList/:user_id/:year/:month',
              name: '経費精算詳細(管理者)',
              component: ExpenseInfoAdmin,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'admin/payoff',
          redirect: 'admin/payoff/travelCostList',
          name: '通勤費精算一覧',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: ':travelCostList',
              component: TravelCostListAdmin,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: '/travelCostList/:user_id/:year/:month',
              name: '通勤費精算詳細(管理者)',
              component: TravelCostInfoAdmin,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'payoff',
          redirect: '/payoff/expense',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'expense',
              name: '経費精算',
              component: Expense
            }
          ]
        },
        {
          path: 'payoff',
          redirect: '/payoff/travelCost',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'travelCost',
              name: '通勤費精算',
              component: TravelCost
            },
          ]
        },
        {
          path: 'submission_approval',
          redirect: '/submission_approval/report_list',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'report_list',
              name: '承認申請一覧',
              component: ReportList
            }
          ]
        },
        {
          path: 'submission_approval',
          redirect: '/submission_approval/submission_management',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'submission_management',
              name: '承認待ち一覧',
              component: SubmissionManagement
            }
          ]
        },
        {
          path: 'theme',
          redirect: '/theme/colors',
          name: 'Theme',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'colors',
              name: 'Colors',
              component: Colors
            },
            {
              path: 'typography',
              name: 'Typography',
              component: Typography
            }
          ]
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'users',
          meta: {
            label: 'Users'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'Users',
              component: Users
            },
            {
              path: ':id',
              meta: {
                label: 'User Details'
              },
              name: 'User',
              component: User
            }
          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'forms',
              name: 'Forms',
              component: Forms
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tables',
              name: 'Tables',
              component: Tables
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'standard-buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-groups',
              name: 'Button Groups',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'icons',
          redirect: '/icons/coreui-icons',
          name: 'CoreUI Icons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'coreui-icons',
              name: 'Icons library',
              component: CoreUIIcons
            },
            {
              path: 'brands',
              name: 'Brands',
              component: Brands
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badges',
              name: 'Badges',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'sendEmail',
          name: 'SendEmail',
          component: SendEmail
        },
        {
          path: 'confirmEmail',
          name: 'ConfirmEmail',
          component: ConfirmEmail,
          props: true
        },
        {
          path: 'resetPassword',
          name: 'ResetPassword',
          component: ResetPassword,
          props: route => ({
            id: route.query.id,
            token: route.query.token
          })
        },
        {
          path: 'resetComplete',
          name: 'ResetComplete',
          component: ResetComplete
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
        {
          path: 'user_error',
          name: 'UserError',
          component: UserError
        }
      ]
    }
  ]
}

router.beforeEach((to, from, next) => {
  if (to.name === 'ConfirmEmail') {
    if (to.params.email) {
      next()
    } else {
      next({
        name: 'Login'
      })
    }
    return
  }

  if (to.name === 'ResetPassword') {
    axios
      .get(process.env.VUE_APP_API_ORIGIN + '/token/check', {
        params: {
          token: to.query.token
        }
      })
      .then(response => {
        if (response.data === true) {
          next()
        } else {
          alert('トークンの有効期限が切れました。')
          next({
            name: 'Login'
          })
        }
      })
      .catch(() => {
        next({
          name: 'Login'
        })
      })
    return
  }

  if (to.name === 'Login' || to.name === 'SendEmail' || to.name === 'ResetComplete') {
    next()
    return
  }

  axios
    .get((process.env.VUE_APP_API_ORIGIN) + '/name')
    .then(response => {
      if (response.data && response.status === 200) {
        next()
      } else {
        next({
          name: 'Login'
        })
      }
    })
    .catch(() => {
      next({
        name: 'Login'
      })
    })
})
export default router

